// PreviousRouteContext.tsx
import { createContext, PropsWithChildren, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

type PreviousRouteContextType = {
    previousRoute: string | null;
    clearPreviousRoute: () => void;
    emailFromUrl: string;
    emailSetter: (email: string) => void;
    canGoBackInApp: boolean;
};

const PreviousRouteContext = createContext<PreviousRouteContextType | undefined>(undefined);

export const PreviousRouteProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const [previousRoute, setPreviousRoute] = useState<string | null>(null);
    const [emailFromUrl, setEmailFromUrl] = useState<string>('');
    const currentPathRef = useRef(location.pathname);

    const navType = useNavigationType(); // "PUSH" | "REPLACE" | "POP"
    const [depth, setDepth] = useState(() => Number(sessionStorage.getItem("appDepth") || 1));


    useEffect(() => {
        setPreviousRoute(currentPathRef.current);
        currentPathRef.current = location.pathname;
    }, [location]);

    useEffect(() => {
        if (navType === "PUSH") setDepth(d => d + 1);
        if (navType === "POP")  setDepth(d => Math.max(1, d - 1));
      }, [location.key, navType]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const emailParam = queryParams.get('email');
        setEmailFromUrl(emailParam || '');
    }, [location.search]);

    const clearPreviousRoute = () => {
        setPreviousRoute(null);
    };

    const emailSetter = (email: string) => {
        setEmailFromUrl(email)
    }

    const canGoBackInApp = depth > 1;

    return (
        <PreviousRouteContext.Provider value={{ previousRoute, clearPreviousRoute, emailFromUrl, emailSetter, canGoBackInApp }}>
            {children}
        </PreviousRouteContext.Provider>
    );
};

export const usePreviousRoute = () => {
    const context = useContext(PreviousRouteContext);
    if (!context) {
        throw new Error('usePreviousRoute must be used within PreviousRouteProvider');
    }
    return context;
};
